import { useCallback } from 'react';
import { useTranslations } from 'js/hooks/i18n';
import { always, cond, equals, isNil, partialRight, T } from 'ramda';

export const useProductLimitsTranslate = (tKeyPrefix) => {
    const translate = useTranslations();
    return useCallback(
        (tk, ...args) => translate(`${tKeyPrefix}${tk}`, ...args),
        [translate, tKeyPrefix]
    );
};

export const formatCurrency = ({ formatter, tt, currencyCode, precision = 0, unlimitedValue }) =>
    cond([
        [equals(unlimitedValue), always(tt('unlimited'))],
        [isNil, always(tt('unset'))],
        [T, partialRight(formatter.formatCurrency, [{ currencyCode, precision }])]
    ]);
